/* eslint-disable import/prefer-default-export */
export var SPRINGS_PRODUCT_ID = 6721668229;
export var sorts = [{
  orderBy: '-rating,-created_at',
  label: 'Rating (high - low)',
  value: 'rating-high'
}, {
  orderBy: 'rating,-created_at',
  label: 'Rating (low - high)',
  sort: true,
  value: 'rating-low'
}, {
  orderBy: '-created_at',
  label: 'Most Recent',
  sort: true,
  value: 'most-recent'
}, {
  orderBy: '-score,-created_at',
  label: 'Most Helpful',
  sort: true,
  value: 'most-helpful'
}];
export var allReviewsUrl = function allReviewsUrl(id) {
  return "/pages/product-reviews?product_id=".concat(id);
};
export var submitReviewUrl = function submitReviewUrl(id, variantId) {
  return "/pages/submit-a-review?product_id=".concat(id).concat(variantId ? '&variant=' + variantId : '');
};